export function toEnum<T extends Record<string, string | number>>(
  value: string | null | undefined,
  enumType: T
): T[keyof T] {
  if (!value) {
    throw new Error(`Input must be defined and non-empty JSON object`);
  }

  if (Object.values(enumType).includes(value as T[keyof T])) {
    return value as T[keyof T];
  }

  throw new Error(`Incompatible enum. Value does not match any enum value`);
}
